import { InternalTransportFormValues } from "../types/internalTransportTable.types";

export const DEFAULT_FORM_VALUES: InternalTransportFormValues = {
  id: "",
  name: "",
  averageDistance: "",
  transportType: "",
  weight: "",
  weightUnit: "kg"
};
